import { es } from 'date-fns/locale';
import { formatInTimeZone, fromZonedTime, toZonedTime } from 'date-fns-tz';

export const CHILE_TIMEZONE = 'America/Santiago';

const COUNTRY_IANA_TZ: Record<string, string> = {
  CL: 'America/Santiago',
  AR: 'America/Argentina/Buenos_Aires',
  MX: 'America/Mexico_City',
  CO: 'America/Bogota',
  VE: 'America/Caracas',
};

export function getEventIanaTimezone(eventSlug: string): string {
  const country = eventSlug.split('-')[1]?.toUpperCase();
  if (country && COUNTRY_IANA_TZ[country]) return COUNTRY_IANA_TZ[country];
  return CHILE_TIMEZONE;
}

export function formatEventWeekendRangeEs(
  startsAt: Date | string | null | undefined,
  endsAt: Date | string | null | undefined,
  timezone: string,
): string | null {
  if (!startsAt || !endsAt) return null;
  const start = typeof startsAt === 'string' ? new Date(startsAt) : startsAt;
  const end = typeof endsAt === 'string' ? new Date(endsAt) : endsAt;
  const startStr = formatInTimeZone(start, timezone, "EEEE d 'de' MMMM HH:mm", {
    locale: es,
  });
  const endStr = formatInTimeZone(end, timezone, "EEEE d 'de' MMMM HH:mm", {
    locale: es,
  });
  const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
  return `${cap(startStr)} hasta ${cap(endStr)}`;
}

export function dateTimeLocalToChileDate(
  dateTimeLocal: string | undefined,
): Date | null {
  if (!dateTimeLocal) return null;

  const [datePart, timePart] = dateTimeLocal.split('T');
  const [year, month, day] = datePart.split('-').map(Number);
  const [hour, minute] = timePart.split(':').map(Number);

  const dateInChile = new Date(year, month - 1, day, hour, minute);

  return fromZonedTime(dateInChile, CHILE_TIMEZONE);
}

export function chileDateToDateTimeLocal(date: Date | null): string {
  if (!date) return '';

  const dateInChile = toZonedTime(date, CHILE_TIMEZONE);

  const year = dateInChile.getFullYear();
  const month = String(dateInChile.getMonth() + 1).padStart(2, '0');
  const day = String(dateInChile.getDate()).padStart(2, '0');
  const hours = String(dateInChile.getHours()).padStart(2, '0');
  const minutes = String(dateInChile.getMinutes()).padStart(2, '0');

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}
